import { useCallback, useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { Link, Redirect } from "react-router-dom/cjs/react-router-dom.min"
import "./Dashboard.css"
import { SoundboardSlots, deleteSlotEntry } from "./SoundboardSlots"
import { SOUNDBOARD_POSITIONS_URL, USER_DASHBOARD_URL, PROMO_DASHBOARD_URL } from "../Api"
import ErrorWindow from "../Indicators/ErrorWindow"
import { APP_DIRECTORY } from "../SystemVariables"

const RightSide = (username) => {
    let userInfo = (<div></div>)
    if(username !== undefined) {
        userInfo = (<div className="rightSideItem"><div className="rightSideContent"><Link to={`${APP_DIRECTORY}/profile`}>{username}</Link></div></div>)
    }
    const aboutLink = <div className="rightSideItem"><div className="rightSideContent"><a href="../about/?returnTo=/app/">About</a></div></div>
    const rightSide = (<div className="rightSide">{aboutLink}{userInfo}</div>)
    return rightSide
}

const Header = (username, editButton) => {
    const rightSide = RightSide(username)
    const header = (<div className="header">{editButton}{rightSide}</div>)
    return header
}

const LandingHeader = () => {
    const leftSide = (<div className="promoLeftSide">
        <div className="headerText"><a href="../about/?returnTo=/app/">About</a></div>
    </div>)
    const rightSide = (<div className="promoRightSide">
        <Link to={`${APP_DIRECTORY}/login`}>Create your own!</Link>
    </div>)
    return (<div className="header">{leftSide}{rightSide}</div>)
}

const DeleteButton = (props) => {
    if(props.edit) {
        return <div className="deleteButtonArea">
            <Button variant="danger" onClick={()=>{props.setEdit(false)}}>Don't delete</Button>
        </div>
    } else {
        return <div className="deleteButtonArea">
            <Button onClick={()=>{props.setEdit(true)}}>Delete</Button>
        </div>
    }
}

const handleResponse = (response) => {
    if(response.ok) {
        return response.json()
    } else {
        const error = new Error("Something went wrong")
        error.response = response
        throw error
    }
}

const Dashboard = (props) => {
    const [soundboardPositions, setSoundboardPositions] = useState([])
    const [dashboardEntries, setDashboardEntries] = useState([])
    const [redirect, setRedirect] = useState(undefined)
    const [edit, setEdit] = useState(false)
    const [error, setError] = useState(undefined)
    const [deleting, setDeleting] = useState(undefined)

    const handleErrorResponse = useCallback((err) => {
        if(err.response !== undefined) {
            err.response.json()
            .then(data=>{
                if(data.code === "token_not_valid") {
                    props.clearLoginData()
                } else if(err.response.status === 406) {
                    setError(`${data['status']}`)
                } else {
                    setError("An unexpected error occurred! Please try reloading the page.")
                    props.clearLoginData() // the safest thing is to make the user log out
                }
            })
        } else {
            setError("An unexpected error occurred. Please try reloading the page.")
            props.clearLoginData() // the safest thing is to make the user log out
        }
    }, [props])

    const loadDashboardEntries = useCallback(() => {
        fetch(USER_DASHBOARD_URL, {
            method: 'get',
            headers: {'Authorization':`Bearer ${props.accessToken}`},
        })
        .then(response=>{ return handleResponse(response) })
        .then(response=>{ setDashboardEntries(response.dashboardEntries) })
        .catch(err => handleErrorResponse(err))
    }
    , [props.accessToken, handleErrorResponse])

    const loadSoundboardPositions = useCallback(() => {
        fetch(SOUNDBOARD_POSITIONS_URL, {
            method: 'get',
            headers: {'Authorization':`Bearer ${props.accessToken}`},
        })
        .then(response=>{ return handleResponse(response) })
        .then(response=>{ setSoundboardPositions(response) })
        .catch(err => handleErrorResponse(err))
    }, [props.accessToken, handleErrorResponse])

    const loadPromoDashboard = useCallback(() => {
        fetch(PROMO_DASHBOARD_URL)
        .then(response=>{ return handleResponse(response) })
        .then(response=>{
            const promoEntries = response.dashboardEntries
            const dummyPositions = []
            promoEntries.forEach(e=>{
                const positionName = e.position
                dummyPositions.push({'slot': positionName})
            })
            setSoundboardPositions(dummyPositions)
            setDashboardEntries(promoEntries)
        })
        .catch(err=>handleErrorResponse(err))
    }, [handleErrorResponse])

    useEffect(()=>{
        if(props.landingDashboard) {
            loadPromoDashboard()
        } else if(props.accessToken !== undefined && props.accessToken !== null) {
            loadDashboardEntries()
            loadSoundboardPositions()
        }
    },[props.accessToken, loadDashboardEntries, loadSoundboardPositions, props.landingDashboard, loadPromoDashboard])

    if(redirect) {
        return(<Redirect to={`${APP_DIRECTORY}/uploadFile/${redirect}`}/>)
    } else if(!props.accessToken && !props.landingDashboard) {
        return(<Redirect to={`${APP_DIRECTORY}/login/`}/>)
    } else if(error) {
        return(<ErrorWindow message={error} continue={()=>{setError(undefined)}}/>)
    } else if(props.landingDashboard) {
        const showError = (message) => {
            setError(message)
        }

        const header = LandingHeader()
        const soundboardSlots = SoundboardSlots(soundboardPositions, dashboardEntries, false, ()=>{}, setRedirect, showError, false)
        return (
            <div className="dashboard">
                {header}
                {soundboardSlots}
            </div>
        )
    } else {
        const deleteButton = <DeleteButton setEdit={setEdit} edit={edit}/>

        const onDeleteComplete = () => {
            loadDashboardEntries()
            setDeleting(undefined)
        }

        const onDeleteSlot = (slotName) => {
            setDeleting(slotName)
            deleteSlotEntry(slotName, props.accessToken, onDeleteComplete, showError)
        }

        const showError = (message) => {
            setError(message)
            setDeleting(undefined)
        }
        const header = Header(props.username, deleteButton)
        const soundboardSlots = SoundboardSlots(soundboardPositions, dashboardEntries, edit, onDeleteSlot, setRedirect, showError, deleting)
        return (
            <div className="dashboard">
                {header}
                {soundboardSlots}
            </div>
        )
    }
}

export default Dashboard
